import { Component } from '@angular/core';

@Component({
  selector: 'app-buttom-logo',
  imports: [],
  templateUrl: './buttom-logo.component.html',
  styleUrl: './buttom-logo.component.css'
})
export class ButtomLogoComponent {

}
